var ticket;
var local = window.localStorage;
// var urlHeader = 'http://test.yulu.meng-dong.com/access';
var urlHeader = '/access';

function initWebReqHeader() {
  var seq = parseInt(local.getItem('income_seq')) | 0;
  seq += 1;
  localStorage.setItem('income_seq', seq);
  var WebReqHeader = {
    uuid: getUuid(),
    ua: navigator.userAgent,
    ticket: local.getItem('income_ticket'),
    seq: seq,
  }
  if (local.getItem('income_ticket') == null) {
    delete WebReqHeader.ticket;
  }
  return WebReqHeader;
}

function isLogin() {
  return isExist('income_ticket') && isExpired();
}

function isExist(item) {
  return window.localStorage.getItem(item) != null;
}

function isExpired() {
  if (local.getItem('income_ticket_validTime') == null) {
    return false;
  }
  var currentTime = (new Date()).getTime();
  return currentTime < parseInt(local.getItem('income_ticket_validTime'));
}

function getURLParameter(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null
}

function getUuid() {
  if (local.getItem('income_uuid') != null) {
    return local.getItem('income_uuid');
  } else {
    var timeNow = new Date();
    local.setItem('income_uuid', timeNow.getTime().toString());
    return timeNow.getTime().toString();
  }
}

function myConfirmAlert(errorDes) {
  $('.alert-msg').text(errorDes);
  $('.alert-area').show();
  $('.alert-confirm').click(function(event) {
    event.stopPropagation()
    $('.alert-area').hide();
  });
}

function myLinkAlert(promptDes, linkUrl) {
  $('.alert-msg').text(promptDes);
  $('.alert-area').show();
  $('.alert-confirm').click(function() {
    window.location.href = linkUrl;
  });
}

function back() {
  window.history.go(-1);
}

function clearLoginMsg() {
  localStorage.removeItem('income_ticket');
  localStorage.removeItem('income_ticket_validTime');
  localStorage.removeItem('income_tel');
  localStorage.removeItem('income_userId');
  localStorage.removeItem('income_userName');
  localStorage.removeItem('income_userType');
  localStorage.removeItem('income_head_img_url');
  localStorage.removeItem('income_ismengdongapp');
}

function autoLoginWithTicket() {
  local.setItem('income_userId', getURLParameter('userId'));
  local.setItem('income_ticket', getURLParameter('ticket'));
  var currentTime = new Date();
  var expireTime = currentTime.getTime() + 86400 * 1000;
  local.setItem('income_ticket_validTime', expireTime);
}

function getMonthFromPeriod(period) {
  return parseInt(period.substring(5));
}

function isFromApp() {
  if (getURLParameter('ismengdongapp') != null) {
    localStorage.setItem('income_ismengdongapp', getURLParameter('ismengdongapp'))
    return true;
  }
  localStorage.removeItem('income_ismengdongapp');
  return false;
}

function getLocalDate(date) {
  return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
}

function formatDateTime(ts, sep) {
  if (ts == undefined || ts == null) {
    return "---";
  }
  if (ts.toString().length != 10) {
    return "---";
  }
  var currentDate = new Date(ts * 1000);
  var timeString = showAsTime(currentDate.getHours()) + ":" + showAsTime(currentDate.getMinutes()) + ":" + showAsTime(currentDate.getSeconds());
  return getLocalDate(currentDate) + (sep == undefined ? " " : sep) + timeString;
}

function showAsTime(num) {
  if (num < 10) {
    return "0" + num;
  }
  return num;
}

function showThirtyDaysTime(startTs, sep) {
  return formatDateTime(startTs + 30 * 24 * 60 * 60, sep);
}

function calcRentalDays(startTs) {
  var currentDate = new Date();
  var year = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1;
  var day = currentDate.getDate();
  var currentDateString = year + '/' + month + '/' + day;
  var current = new Date(currentDateString).getTime();
  timeDiff = current / 1000 - startTs;
  var oneDay = 24 * 60 * 60;
  if (timeDiff < 0) {
    return 0;
  }
  if (timeDiff < 30 * oneDay) {
    return 30;
  }
  return timeDiff / oneDay + 1;
}

function calcRentalIncome(startTs) {
  var rentalDay = calcRentalDays(startTs);
  if (rentalDay < 30 && rentalDay > 0) {
    return 600;
  }
  return rentalDay * 2000;
}
